import React from 'react';

import { Skeleton } from 'components/common';

const CartLoading = () => {
  return <Skeleton type="table" />;
};

CartLoading.propTypes = {};

export default CartLoading;
